import { Component } from 'react';
import { ImageProps } from '../Image';
import {
    AvatarBadgeElement,
    AvatarContainerElement,
    AvatarElement,
    AvatarImageElement,
    AvatarStyleProps,
    BadgeImageElement,
    BadgeTitleElement,
    NotificationElement,
    TitleElement,
} from './style';

export interface AvatarProps extends AvatarStyleProps, Omit<ImageProps, 'src'> {
    src: string;
    hasNotification?: boolean;
    badgeAttributes?: ImageProps;
    badgePosition?: 'left' | 'right';
}

const factory = ({
    Avatar = AvatarElement,
    AvatarContainer = AvatarContainerElement,
    Image = AvatarImageElement,
} = {}) =>
    class extends Component<AvatarProps> {
        static displayName = 'Avatar';

        render() {
            const {
                alt,
                badgeAttributes,
                badgePosition = 'right',
                children,
                title,
                src,
                srcSet,
                sizes,
                small,
                hasNotification,
                size,
                ...other
            } = this.props;

            return (
                <AvatarContainer {...other}>
                    <Avatar small={small} size={size}>
                        {src && <Image src={src} alt={alt} srcSet={srcSet} sizes={sizes} />}
                        {!src && title && <TitleElement>{title[0]}</TitleElement>}
                    </Avatar>
                    {hasNotification && <NotificationElement />}
                    {badgeAttributes && (
                        <AvatarBadgeElement position={badgePosition}>
                            {badgeAttributes.src && <BadgeImageElement {...badgeAttributes} />}
                            {!badgeAttributes.src && badgeAttributes.title && (
                                <BadgeTitleElement>{badgeAttributes.title[0]}</BadgeTitleElement>
                            )}
                        </AvatarBadgeElement>
                    )}
                    {children}
                </AvatarContainer>
            );
        }
    };

export { factory as avatarFactory };
export default factory();
